import * as React from "react";
import { request } from "../../../services/cpln";
import { formSetValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { parseLink } from "../../../utils/linkParser/linkParser";
import { fetchGvcLocations } from "../../../mst/kinds/gvc.helpers";

export interface GvcLocationOption {
  label: string;
  value: string;
}

export const GvcLocationFetcher: React.FC = () => {
  const { id } = useCpFormContext();
  const gvc = useCpFormValue(`gvc`);
  const gvcLocations = useCpFormValue(`meta.gvcLocations`);

  const gvcLinkRef = React.useRef<string | null>(null);

  React.useEffect(() => {
    // Skip if link hasn't changed AND locations are already loaded/loading (not undefined)
    if (gvc.link === gvcLinkRef.current && gvcLocations !== undefined) {
      return;
    }
    gvcLinkRef.current = gvc.link;

    if (!gvc.link) {
      formSetValue(id, `meta.gvcLocations`, []);
      return;
    }

    loadGvcLocations();
  }, [gvc.link, gvcLocations]);

  async function loadGvcLocations() {
    formSetValue(id, `meta.gvcLocations`, null); // null = loading sentinel (prevents re-fetch loop)
    formSetValue(id, `meta.gvcLocationsFetchFailed`, false);
    try {
      // Get GVC data if not already present
      let gvcData = gvc.item;
      if (!gvcData) {
        const parsedLink = parseLink(gvc.link, { useInputCtx: true });
        const fetchUrl = parsedLink.isValid ? parsedLink.absolute : gvc.link;
        const { data } = await request({ url: fetchUrl });
        gvcData = data;
        // Also update the gvc.item in form
        formSetValue(id, `gvc.item`, data);
      }

      const result = await fetchGvcLocations(gvc.link, gvcData);
      const locationOptions: GvcLocationOption[] = result.enabled.map((name) => ({
        label: name,
        value: name,
      }));

      formSetValue(id, `meta.gvcLocations`, locationOptions);
    } catch (e) {
      // On error, set empty array and mark as failed
      formSetValue(id, `meta.gvcLocations`, []);
      formSetValue(id, `meta.gvcLocationsFetchFailed`, true);
    }
  }

  return null;
};
